import React from "react";
import PopUp, { closePopUp } from "../../components/popUp";
import Button from "../../components/button";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useNavigate } from "react-router-dom";

export default function PurchaseCancelPopUp(props: {pieceId?: number}) {

    const navigate = useSafeNavigate(useNavigate());

    return <PopUp title="Purchase Cancelled">
        <p>Your purchase has been cancelled.</p>
        <Button onClick={() => {
            closePopUp();
            if(props.pieceId) {

                navigate("/pieces/" + props.pieceId);
            }
        }}>Ok</Button>
    </PopUp>

}